import { useCallback, useContext } from 'react';

import {
  sendAnalyticsInfo,
  sendAnalyticsWarning,
} from 'features/analytics/helpers';
import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import {
  isDeafConnectedSelector,
  selectIsDeafUserFromSorenson,
} from 'features/call/call-deaf/store';
import { selectIsViConnectedToFreeSwitchConference } from 'features/caller-session/store';
import { SipSessionContext } from 'features/sip/contexts';
import { SipSessionEventBus } from 'features/sip/services/';
import { isTeamingInProgressSelector } from 'features/teaming/teaming-base/store';

export const useEnableFlasher = () => {
  const session = useContext(SipSessionContext);
  const dispatch = useAppDispatch();
  const isDeafConnected = useAppSelector(isDeafConnectedSelector);
  const isSorenson = useAppSelector(selectIsDeafUserFromSorenson);
  const isTeamingInProgress = useAppSelector((state) =>
    isTeamingInProgressSelector(state)
  );
  const isViInFreeSwitchRoom = useAppSelector(
    selectIsViConnectedToFreeSwitchConference
  );
  const showEnableFlasher =
    isDeafConnected &&
    isSorenson &&
    !isTeamingInProgress &&
    !isViInFreeSwitchRoom;

  const handleEnableFlasher = useCallback(() => {
    const contentType = 'application/im-poke+xml';
    const body =
      '<?xml version="1.0" encoding="UTF-8"?>\n<poke xmlns="urn:ietf:params:xml:ns:im-poke" />';
    const target = session?.remote_identity?.uri?.toString() || '';
    if (target) {
      SipSessionEventBus.outgoingMessage$.next({ target, body, contentType });
      dispatch(
        sendAnalyticsInfo({
          Method: 'EnableFlasher',
          Message: 'Sent SIP poke message',
          Target: target,
        })
      );
    } else {
      dispatch(
        sendAnalyticsWarning({
          Method: 'EnableFlasher',
          Message: 'No valid SIP target found',
        })
      );
    }
  }, [session, dispatch]);
  return [showEnableFlasher, handleEnableFlasher] as const;
};
